import { ErrorComponent, ThemedLayoutV2 } from '@refinedev/mui';
import { NavigateToResource } from '@refinedev/react-router';
import { Route, Routes, useParams } from 'react-router';
import { Header } from '../../../components/header/index.tsx';
import { Sider } from '../../../components/organization/Sider.tsx';
import * as Account from './account/index.ts';

export default () => {
  const { organizationId } = useParams<{ organizationId: string }>();

  return (
    <ThemedLayoutV2 Header={Header} Sider={Sider}>
      <Routes>
        <Route
          index
          element={<NavigateToResource resource={`organization/${organizationId}/accounts`} />}
        />
        <Route path="/accounts">
          <Route index element={<Account.AccountList />} />
          <Route path="create" element={<Account.AccountForm action="create" />} />
          <Route path="edit/:id" element={<Account.AccountForm action="edit" />} />
          <Route path="show/:id" element={<Account.AccountShow />} />
        </Route>
        <Route path="*" element={<ErrorComponent />} />
      </Routes>
    </ThemedLayoutV2>
  );
};
